var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDiscoverIcon = function SvgDiscoverIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#discover-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.819 18.358a.4.4 0 0 1 .369-.71 8.5 8.5 0 0 0 11.46-11.464.4.4 0 1 1 .709-.369A9.26 9.26 0 0 1 19.4 10.1a9.3 9.3 0 0 1-9.3 9.3 9.26 9.26 0 0 1-4.282-1.042ZM13.966 1.64a.4.4 0 0 1-.333.727A8.5 8.5 0 0 0 2.37 13.64a.4.4 0 0 1-.726.334A9.3 9.3 0 0 1 13.967 1.64v-.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.273 11.266 6.283-8.821-8.82 6.283-6.284 8.821 8.82-6.283Zm-9.327 7.626a.6.6 0 0 1-.837-.837l7.052-9.9 9.9-7.052a.6.6 0 0 1 .837.836l-7.052 9.9-9.9 7.053Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.15 8.772.566-.565 3.111 3.111-.565.566L8.15 8.772ZM9.602 17.6a.4.4 0 0 1 .8 0V19a.4.4 0 0 1-.8 0v-1.4ZM9.602 1.2a.4.4 0 0 1 .8 0v1.4a.4.4 0 0 1-.8 0V1.2ZM2.7 9.7a.4.4 0 0 1 0 .8H1.3a.4.4 0 0 1 0-.8h1.4ZM18.902 9.7a.4.4 0 0 1 0 .8h-1.4a.4.4 0 0 1 0-.8h1.4ZM3.893 6.053a.4.4 0 1 1-.4.693l-1.213-.7a.4.4 0 0 1 .4-.692l1.213.7ZM17.922 14.153a.4.4 0 0 1-.4.693l-1.212-.7a.4.4 0 1 1 .4-.693l1.212.7ZM6.747 3.491a.4.4 0 0 1-.693.4l-.7-1.212a.4.4 0 0 1 .693-.4l.7 1.212ZM14.847 17.522a.4.4 0 0 1-.693.4l-.7-1.213a.4.4 0 0 1 .693-.4l.7 1.213Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "discover-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgDiscoverIcon;